import _regeneratorRuntime from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/lib/jenkins/jobs/workspace/tradingblock_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import * as tslib_1 from "tslib";
import { HttpProvider, getAxiosClient } from './providers/httpProvider';
import { LocalStorageProvider } from './providers/localStorageProvider';
export var keyVal = function keyVal(key, prefix) {
  return prefix ? "".concat(prefix, ".").concat(key) : key;
};
export var StorageEngineFactory = function StorageEngineFactory(config) {
  return config.kind === 'http' ? HttpProvider(getAxiosClient(config), Object.assign({}, config, {
    logEndpoint: 'events'
  })) : LocalStorageProvider(config);
};
export var HttpStorageEngineFactory = function HttpStorageEngineFactory(axios, config) {
  return HttpProvider(axios, Object.assign({}, config, {
    logEndpoint: 'events'
  }));
};
export var StorageProvider =
/*#__PURE__*/
function () {
  function StorageProvider(storeConfig) {
    var _this = this;

    var engineFactory = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : StorageEngineFactory;

    _classCallCheck(this, StorageProvider);

    this.delete = function (key) {
      return tslib_1.__awaiter(_this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.engine.delete(keyVal(key, this.config.prefix));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    };

    this.config = storeConfig;
    this.engineFactory = engineFactory;
    this.engine = engineFactory(storeConfig);
  } // const { providerType, prefix, authToken, headers, url, expires } = args;


  _createClass(StorageProvider, [{
    key: "save",
    value: function save(key, value) {
      return this.engine.save(keyVal(key, this.config.prefix), value);
    }
  }, {
    key: "update",
    value: function update(key, value) {
      return this.engine.update(keyVal(key, this.config.prefix), value);
    }
  }, {
    key: "get",
    value: function get(key) {
      return this.engine.get(keyVal(key, this.config.prefix));
    }
  }, {
    key: "log",
    value: function log(value) {
      return this.engine.log(value);
    }
  }, {
    key: "setConfig",
    value: function setConfig(newVal) {
      this.config = newVal;
      this.engine = this.engineFactory(newVal);
    }
  }]);

  return StorageProvider;
}();